export const WHATSAPP_NUMBER = '+52 (561) 756 4391';